import { render, staticRenderFns } from "./UnitStar.vue?vue&type=template&id=3522f20c&"
import script from "./UnitStar.vue?vue&type=script&lang=js&"
export * from "./UnitStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3522f20c')) {
      api.createRecord('3522f20c', component.options)
    } else {
      api.reload('3522f20c', component.options)
    }
    module.hot.accept("./UnitStar.vue?vue&type=template&id=3522f20c&", function () {
      api.rerender('3522f20c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25WzVhz75a9O0/JS/UnitStar.vue"
export default component.exports